import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";

interface VendorSearchProps {}

export const VendorSearch: React.FC<VendorSearchProps> = () => {
    const navigate = useNavigate();

    const [searchTerm, setSearchTerm] = useState("");

    const handleSearch = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        navigate(`/vendors?p=1&search=${encodeURIComponent(searchTerm)}`);
    };

    return (
        <div className="filter clear" style={{ display: "block" }}>
            <form onSubmit={handleSearch}>
                <div className="content">
                    <p>
                        <label>
                            <strong>Otsing:</strong>
                        </label>
                        <input
                            className="text example"
                            type="text"
                            name="search"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                        &nbsp;&nbsp;&nbsp;
                    </p>
                </div>
                <p className="action">
                    <button type="submit">
            <span>
              <strong>Otsi</strong>
            </span>
                    </button>
                    <Link to="/vendors/new" className="filter-secondary">
                        Lisa uus hankija
                    </Link>
                </p>
            </form>
        </div>
    );
};